export const HOUR_OPTIONS = Array.from({ length: 15 }, (_unused, index) => ({
  value: index + 6, label: `${index + 6}h`
}))

export const DAYS_OF_WEEK = [
  { value: 1, label: 'Lundi' },
  { value: 2, label: 'Mardi' },
  { value: 3, label: 'Mercredi' },
  { value: 4, label: 'Jeudi' },
  { value: 5, label: 'Vendredi' },
  { value: 6, label: 'Samedi' },
  { value: 0, label: 'Dimanche' }
]

export const MONTH_NAMES = [
  { value: 1, label: 'Janvier' },
  { value: 2, label: 'Février' },
  { value: 3, label: 'Mars' },
  { value: 4, label: 'Avril' },
  { value: 5, label: 'Mai' },
  { value: 6, label: 'Juin' },
  { value: 7, label: 'Juillet' },
  { value: 8, label: 'Août' },
  { value: 9, label: 'Septembre' },
  { value: 10, label: 'Octobre' },
  { value: 11, label: 'Novembre' },
  { value: 12, label: 'Décembre' }
]

export const ALL_MONTHS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

export const MONTH_DAYS = Array.from({ length: 28 }, (_unused, index) => ({
  value: index + 1, label: `${index + 1}`
}))

const sortAndJoin = items => [...items].sort((first, second) => first - second).join(',')

const parseCronPart = (part, fallback) => {
  if (!part || part === '*')
    return fallback
  return part.split(',').map(Number).filter(Number.isFinite)
}

export const parseCron = cronExpression => {
  if (!cronExpression || cronExpression === 'custom')
    return null
  const parts = cronExpression.split(' ')
  if (parts.length < 5)
    return null

  const [, hoursPart, monthDaysPart, monthsPart, weekDaysPart] = parts
  const hours = parseCronPart(hoursPart, [7])

  const isWeekly = monthDaysPart === '*' && weekDaysPart !== '*'
  const isMonthly = monthDaysPart !== '*' && weekDaysPart === '*'

  let frequency = 'daily'
  if (isWeekly)
    frequency = 'weekly'
  else if (isMonthly)
    frequency = 'monthly'

  return {
    frequency,
    hours: hours.length > 0 ? hours : [7],
    weekDays: parseCronPart(weekDaysPart, [1]),
    monthDays: parseCronPart(monthDaysPart, [1]),
    months: parseCronPart(monthsPart, ALL_MONTHS)
  }
}

const withFallback = (values, fallback) => values.length > 0 ? values : fallback

export const buildCron = ({ frequency, hours, weekDays, monthDays, months }) => {
  const hoursPart = sortAndJoin(withFallback(hours, [7]))
  const monthsPart = months.length === 12 || months.length === 0 ? '*' : sortAndJoin(months)
  if (frequency === 'weekly')
    return `0 ${hoursPart} * ${monthsPart} ${sortAndJoin(withFallback(weekDays, [1]))}`
  if (frequency === 'monthly')
    return `0 ${hoursPart} ${sortAndJoin(withFallback(monthDays, [1]))} ${monthsPart} *`
  return `0 ${hoursPart} * ${monthsPart} *`
}

// Follow each option list's declared order. DAYS_OF_WEEK is Monday-first (the
// French week), not the numeric cron order where Sunday is 0.
const sortedLabels = (options, numbers) =>
  options.filter(option => numbers.includes(option.value))
    .map(option => option.label)
    .join(', ')

export const buildCronSummary = ({ frequency, hours, weekDays, monthDays, months }) => {
  const hourText = sortedLabels(HOUR_OPTIONS, hours)

  let dayText = 'tous les jours'
  if (frequency === 'weekly')
    dayText = `chaque ${sortedLabels(DAYS_OF_WEEK, weekDays)}`
  if (frequency === 'monthly')
    dayText = `le ${sortedLabels(MONTH_DAYS, monthDays)} de chaque mois`

  let monthText = ''
  if (months.length < 12)
    monthText = `, uniquement en ${sortedLabels(MONTH_NAMES, months)}`

  return `Le récapitulatif sera envoyé ${dayText} à ${hourText}${monthText}.`
}
